
import { Component, Vue, Prop } from 'vue-property-decorator';
import { FieldObject } from '~/interfaces/field.interface';
import Field from '~/components/Field.vue';
import { displayData } from '~/helpers';
import { humanReadableField } from '~/filters/humanReadableField';
import { copyToClipboard } from '~common-helpers';

@Component({
    components: {
        Field,
    },
})
export default class Data extends Vue {
    @Prop() title!: string;
    @Prop() data!: FieldObject[];

    copyDataToClipboard() {
        const formattedData = this.data.map((el) => `${humanReadableField(el.key)}: ${displayData(el)}`);
        copyToClipboard(this.title + '\n' + formattedData.join('\n'));
    }
}
